export default "__VITE_ASSET__sajfHRnF__"